import React from 'react';

import './Settings.css';

const Settings = () => {
  return (
    <div className="settings-container">
      <div className="main-content">
        <header className="settings-header">
          <h1>Settings</h1>
        </header>
        <div className="settings-content">
          {/* Placeholder for settings form */}
          <p>Settings form will be displayed here.</p>
        </div>
      </div>
    </div>
  );
};

export default Settings;
